export default "__VITE_ASSET__DLOUJ3AZ__"